<template>
  <div class="comp-out-call-kty call-cxkj-popup" v-if="visible">
    <!-- <template #title> -->
    <div class="mky-header" @mousedown="handleRemove">
      <span class="del" @click="close"><icon-close v-if="status !== 'out.progress' && status !== 'out.accepted'" /></span>
      <jw-space>
        <template v-if="initConfig.userName">
          <label class="label">分机号码:</label>
          <span class="label-num">{{ initConfig.userName }} </span>
        </template>
        <label class="label">当前状态:</label>
        <!-- {{ status || 1 }} -->
        <jw-tag size="mini" v-if="classnameObj[status]" :color="classnameObj[status]?.color || '#86909c'">{{ classnameObj[status]?.label || '' }}</jw-tag>
        <jw-button v-if="!classnameObj[status]" type="primary" size="small" @click="reLogin">注册</jw-button>
      </jw-space>
    </div>
    <!-- </template> -->
    <div class="mky-content">
      <p>
        <!-- <span v-if="status">请先注册分机状态后再拨打</span> -->
        <span v-if="status === 'ua.registered'">状态正常可拨打</span>
        <!-- <span v-else-if="status === 'CB_KICKOUT'">您的电话账号已在其他地方登陆，本地已强制下线！</span> -->
        <span v-else-if="classnameObj[status]">{{ classnameObj[status].label }}</span>
        <span v-else></span>
      </p>
      <div class="phone">{{ detail.callee || '暂无号码' }}</div>
      <div class="icon hangup" v-if="status === 'ua.registered' || status === 'out.terminated'" style="color: #00b42a">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone @click="ctiFn.makecall()" />
        </jw-spin>
      </div>
      <div class="icon hangup" v-if="callStatus.includes(status)" style="color: #f53f3f">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone @click="ctiFn.hangUp()" />
        </jw-spin>
      </div>
      <!-- <div v-if="status === 'CB_KICKOUT'">
        <jw-button type="primary" size="small" @click="reLogin">重新登陆</jw-button>
      </div> -->

      <!-- <div class="icon hangup" v-if="ctiData.status === 'CB_READY'" :style="{ color: status === 'Failed' ? '#00b42a' : classnameObj[status]?.color || '#86909c' }">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone class="" @click="phoneHandle" />
        </jw-spin>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onUnmounted } from 'vue';
import { publicService } from '@/api/public-service';
import { Message } from '@arco-design/web-vue';
const visible = ref(false);
// const regStatus = ref(true);
const loading = ref(true);
const status = ref();
const detail = ref({});

const callStatus = ref(['out.progress', 'out.accepted', 'out.rejected', 'out.failed']);
const classnameObj = ref({
  'ua.registered': { class: 'hangup', icon: '', color: '#00b42a', label: '坐席注册成功' },
  'ua.registrationFailed': { class: 'call', icon: '', color: '#f53f3f', label: '注册失败' },
  'out.progress': { class: 'call', icon: '', color: '#f53f3f', label: '振铃中' },
  'out.accepted': { class: 'call', icon: '', color: '#f53f3f', label: '客户已接听' },
  'out.rejected': { class: 'call', icon: '', color: '#f53f3f', label: '客户已拒接' },
  'out.failed': { class: 'call', icon: '', color: '#f53f3f', label: '呼叫失败' },
  'out.terminated': { class: 'call', icon: '', color: '#00b42a', label: '空闲' }
});

const webPhoneEvent = (response, cause, type) => {
  console.warn('8000080, type, cause,response', type, cause, response);
  status.value = type;
};
const webPhoneUa = (response, type) => {
  // console.warn('8000081,type,response', type, response);
  // status.value = type;
  if (type === 'ua.invite') {
    var msg = response.remoteIdentity.uri.user + '来电了，是否接听';
    if (confirm(msg) == true) {
      response.answer();
    } else {
      response.reject();
    }
  }
};

const cxkjPhone = ref();
const userParams = ref({});

// 初始化
const initConfig = reactive({
  userName: '',
  password: '',
  server: 'cc35.cxcall.cn',
  traceSip: false,
  builtinEnabled: true,
  audioElement: 'remoteAudio',
  in: {
    terminated: (response, cause, type) => webPhoneEvent(response, cause, type),
    accepted: (response, cause, type) => webPhoneEvent(response, cause, type),
    bye: (response, cause, type) => webPhoneEvent(response, cause, type),
    rejected: (response, cause, type) => webPhoneEvent(response, cause, type),
    failed: (response, cause, type) => webPhoneEvent(response, cause, type)
  },
  ua: {
    invite: (response, type) => webPhoneUa(response, type),
    registered: (response, type) => webPhoneUa(response, type),
    unregister: (response, cause, type) => webPhoneEvent(response, cause, type),
    registrationFailed: (response, cause, type) => webPhoneEvent(response, type),
    connecting: (response, type) => webPhoneUa(response, type),
    connected: (response, type) => webPhoneUa(response, type),
    disconnecting: (response, type) => webPhoneUa(response, type),
    disconnected: (response, type) => webPhoneUa(response, type)
  }
});

// 常用方法
const ctiFn = {
  // 打电话
  makecall() {
    // cxkjPhone.value?.start()
    const wp = new SIP.SDK.callWebPhone({
      phoneNumber: detail.value?.callee,
      conParam: JSON.stringify({ ...userParams.value, userId: detail.value?.userId, orgId: detail.value?.orgId }),
      out: {
        progress: (response, cause, type) => webPhoneEvent(response, cause, type),
        accepted: (response, cause, type) => webPhoneEvent(response, cause, type),
        rejected: (response, cause, type) => webPhoneEvent(response, cause, type),
        failed: (response, cause, type) => webPhoneEvent(response, cause, type),
        terminated: (response, cause, type) => webPhoneEvent(response, cause, type),
        bye: (response, cause, type) => webPhoneEvent(response, cause, type)
      }
    });
    console.log(8000000136, wp);
  },
  // 挂机
  hangUp() {
    cxkjPhone.value?.hangup?.();
  }
};

// 重新登陆
const reLogin = async () => {
  cxkjPhone.value?.unregister();
  //  注册
  await ctiInit(detail.value);
};
// 初始化
const ctiInit = async (r) => {
  try {
    console.log(3813944, r, initConfig);
    cxkjPhone.value = new SIP.SDK.cxWebPhone(initConfig);
    console.log(800003883945, cxkjPhone.value);
    status.value = 'ua.registered';
    // ctiFn.makecall();
  } catch (e) {
    // loading.value = false;
    console.log(316, e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};

// 获取基本信息
const open = async (params) => {
  console.log(86, params);
  userParams.value = params;
  visible.value = false;
  const doms = document.querySelectorAll('.call-cxkj-popup');
  console.log(105, doms);
  doms.length &&
    doms.forEach((el) => {
      el.style.display = 'none';
    });
  try {
    loading.value = true;
    const json = await publicService.getMkyOutBound(params);
    console.log(21, json);
    loading.value = false;
    if (!json.error) {
      const res = json.result;
      detail.value = res;
      if (!detail.value.ext || !detail.value.password) {
        Message.error('用户名或密码未配置，请联系管理员');
        visible.value = false;
        return;
      }
      visible.value = true;
      initConfig.userName = detail.value.ext;
      initConfig.password = detail.value.password;
      //  注册
      await ctiInit(detail.value);
    } else {
      console.log(113, loading.value, json.error);
      // Message.error(json.error?.msg || '获取数据失败');
    }
  } catch (e) {
    // loading.value = false;
    console.log(1131, e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
// 拨打
// const phoneHandle = () => {};

// 外呼
// const outCall = () => {
//   rtc.call(detail.value.callee);
//   saveData();
// };
// // 挂断
// const hangUp = () => {
//   rtc && rtc.hangup();
// };

// // 关闭弹窗
const close = () => {
  // rtc && rtc?.unregister?.();
  cxkjPhone.value?.unregister();
  visible.value = false;
};

// 导出
defineExpose({
  open
});

// 拖动
const handleRemove = (e) => {
  const tar = e?.target;
  console.log(e);

  const getparent = (t, clas) => {
    console.log(181, t.nodeName);
    if (t.nodeName === 'BODY') {
      return null;
    }
    if (['svg', 'path', 'g', 'circle'].lastIndexOf(t.nodeName) > -1) {
      return getparent(t?.parentNode, clas);
    }
    if (t?.className?.indexOf(clas) > -1) {
      return t;
    } else {
      return getparent(t?.parentNode, clas);
    }
  };
  const dom = getparent(tar, 'call-cxkj-popup');
  console.log(188, dom.offsetLeft, dom.offsetTop);
  if (tar?.nodeName !== 'svg' && (tar?.className?.includes?.('mky-header') || tar?.parentNode?.className?.includes?.('mky-header') || tar?.parentNode?.parentNode?.className?.includes?.('mky-header') || tar?.parentNode?.parentNode?.parentNode?.className?.includes?.('mky-header'))) {
    const disX = e.clientX - dom.offsetLeft;
    const disY = e.clientY - dom.offsetTop;
    console.log(182, disX, disY);
    document.onmousemove = function (e) {
      let left = e.clientX - disX;
      let top = e.clientY - disY;
      if (left < dom.offsetWidth / 2) {
        left = dom.offsetWidth / 2;
      } else if (left > window.innerWidth - dom.offsetWidth / 2) {
        left = window.innerWidth - dom.offsetWidth / 2;
      }
      if (top < dom.offsetHeight / 2) {
        top = dom.offsetHeight / 2;
      } else if (top > window.innerWidth - dom.offsetHeight / 2) {
        top = window.innerWidth - dom.offsetHeight / 2;
      }

      dom.style.left = left + 'px';
      dom.style.top = top + 'px';
    };
    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }
};

onUnmounted(() => {
  close();
});
</script>
<style scoped lang="less">
@import './out-call-cxkj.less';
</style>
